const baseURL = 'https://idosubarusuzuki.com';

export default baseURL;
